import React, { useEffect, useRef, useState } from "react";
import { Button, Image, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { FormHandles, SubmitHandler } from "@unform/core";
import { Form } from "@unform/web";
import * as Yup from "yup";
import getValidationErrors from "../../../../helpers/getValidateErrors";
import { base64toBlob } from "../../../../helpers/utils";

import TabGeral from "./TabGeral";
import TabImagens from "./TabImagens";
import TabLinhasDeAplicacao from "./TabLinhasDeAplicacao";
import TabOutrasCaracteristicas from "./TabOutrasCaracteristicas";

import {
  IFormPerfil,
  IOutrasCaracteristicas,
} from "../../../../common/interfaces/produtos.interfaces";

import { toast } from "react-toastify";
import Placeholder from "../../../../assets/imgs/img-placeholder.png";
import BackButton from "../../../../components/ButtonBack";
import { getSingleErrorMessage } from "../../../../helpers/getSingleErrorMessage";
import history from "../../../../helpers/history";
import api from "../../../../services/api";
import TabTamanhosBarra from "./TabGeral/TabTamanhosDeBarra";

interface IPerfil {
  tipoProduto: string;
}

export interface FSelect {
  value: number;
  label: string;
}

const Perfil: React.FC<IPerfil> = (props) => {
  // URL Params
  const { pId }: any = useParams();

  // Fields
  const novo = pId == 0;
  const baseUrlImagem = `${process.env.REACT_APP_API}figurasicones/perfis/figuras/`;

  // Refs
  const formRef = useRef<FormHandles>(null);

  //States
  const [loadingSave, setLoadingSave] = useState(false);
  const emValidacao = useRef("");
  const [selectValues, setSelectValues] = useState<any>({});
  const [selectLinhaAplicacao, setSelectLinhaAplicacao] = useState<any>({});
  const [outrasCaracteristica, setOutrasCaracteristica] = useState<
    IOutrasCaracteristicas[]
  >([]);
  const [logoPreview, setLogoPreview] = useState([]);
  const [figuraIcone, setFiguraIcone] = useState<any>({});
  const [show, setShow] = useState(false);
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [logoLinha, setLogoLinha] = useState<any>(null);
  const [loadingValues, setLoadingValues] = useState(false);
  const [material, setMaterial] = useState<any>(null);
  const [reload, setReload] = useState(false);

  const [idSituacaoGet, setIdSituacaoGet] = useState<FSelect>();

  const [tamanhoBarrasLiberado, setTamanhoBarrasLiberado] = useState(false);

  const message = "Campo obrigatório";
  const schema = Yup.object().shape({
    status: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    situacao: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    codigo: Yup.string()
      .required(message)
      .max(20, "O código só pode ter no máximo 20 caracteres."),
    codigoInterno: Yup.string().max(
      20,
      "O código interno só pode ter no máximo 20 caracteres."
    ),
    referencia: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    linha: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    descricao: Yup.string()
      .required(message)
      .max(100, "A descrição só pode ter no máximo 100 caracteres."),

    prenativo: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    classeId: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    unidadeValorizacao: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    peso: Yup.string().required(message).nullable(),
    maisDeUmTamanhoBarra: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable()
      .required(message),
    barra1: Yup.number()
      .nullable()
      .when("maisDeUmTamanhoBarra", {
        is: (val: any) => val?.value === false,
        then: (schema) => schema.required(message),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  // Effects
  useEffect(() => {
    const fetchData = async () => {
      if (props.tipoProduto.toUpperCase() == "PERFIL") {
        if (!novo) {
          const { data } = await api.get(`perfil/${pId}`);
          setMaterial(data);
          setTamanhoBarrasLiberado(data?.maisDeUmTamanhoBarra?.value === true);
          emValidacao.current =
            data?.situacao.label == "Em Edição" ||
            data?.situacao.label == "Em Homologação"
              ? "validacao/"
              : "";
          const linhaAplicacao = await api.get(
            `geral/selecaoLinhaAplicacao/${data?.referencia?.value}/PERFIL`
          );
          setSelectLinhaAplicacao(linhaAplicacao.data);
        }
      }
    };

    fetchData();
  }, [props.tipoProduto, reload]);

  useEffect(() => {
    const fetchData = async () => {
      if (props.tipoProduto.toUpperCase() == "PERFIL") {
        setLoadingValues(true);

        let [referencia, tempera, liga, classeId] = await Promise.all([
          api.get("geral/selecaoReferenciaMaterial/PERFIL"),
          api.get("geral/selecaoTempera"),
          api.get("geral/selecaoLiga"),
          api.get("geral/selecaoClasseId"),
        ]);

        setSelectValues({
          referencia: referencia.data,
          tempera: tempera.data,
          liga: liga.data,
          //classeId: classeId.data,
          formRef: formRef,
        });

        if (!novo) {
          const { data } = await api.get(`perfil/${pId}`);
          setMaterial(data);
          setIdSituacaoGet(data.situacao);
          const isMaisDeUmTamanho = data?.maisDeUmTamanhoBarra?.value;
          setTamanhoBarrasLiberado(isMaisDeUmTamanho === true);
        }

        setLoadingValues(false);
      }
    };

    fetchData();
  }, [props.tipoProduto]);

  useEffect(() => {
    material && formRef.current?.setData(material);
  }, [material]);

  // Handles
  const handleClose = () => setShow(false);

  const handleNew = () => {
    setShow(true);
  };

  const handleSubmit: SubmitHandler<IFormPerfil> = async (perfil) => {
    try {
      formRef.current?.setErrors({});
      await schema.validate(perfil, { abortEarly: false });
      perfil.id = pId;

      if (perfil.liga == null) {
        const liga6060 = selectValues.liga.find((p: any) => p.label == "6060");
        perfil.liga = liga6060;
      }

      if (perfil.tempera == null) {
        const temperaT5 = selectValues.tempera.find(
          (p: any) => p.label == "T5"
        );
        perfil.tempera = temperaT5;
      }

      const perfilNumber = {
        ...perfil,
        barra1: perfil.barra1
          ? parseFloat(perfil.barra1.toString().replace(",", "."))
          : 0,
      };

      const {
        data: { id },
      } = await api.post("perfil", perfilNumber);

      toast.success("A ação foi concluída.");
      history.push(`/produtos/${id}/${perfil.codigo.replace("/", "")}/perfil`);
      setReload((reload) => !reload);
    } catch (err) {
      toast.error(getSingleErrorMessage(err));
      formRef.current?.setErrors(getValidationErrors(err));
    }
  };

  const submit = () => {
    setLoadingSave(true);
    setTimeout(() => {
      setLoadingSave(false);
    }, 500);
    formRef.current?.submitForm();
  };

  return (
    (novo || material) && (
      <>
        <div className="card mt-3">
          <div className="card-body mb-2 ">
            <div className="row">
              <span className="col-auto">
                <BackButton />
              </span>
              <span className="col-auto ml-auto">
                <Button
                  className="mr-2"
                  onClick={() => handleNew()}
                  variant="white"
                  disabled={novo}
                >
                  Pré-visualização
                </Button>
              </span>
              <span className="col-auto">
                {loadingSave ? (
                  <Button variant="primary" disabled>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </Button>
                ) : (
                  <Button variant="white" onClick={submit}>
                    Salvar
                  </Button>
                )}
              </span>
            </div>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <Tabs
                defaultActiveKey="geral"
                onSelect={(tab: any) => setSelectedTab(tab)}
              >
                <Tab eventKey="geral" title="Geral">
                  <TabGeral
                    selectValues={selectValues}
                    setLogoLinha={setLogoLinha}
                    loadingValues={loadingValues}
                    material={material}
                  />
                </Tab>
                <Tab
                  disabled={novo}
                  eventKey="outrasCaracteristicas"
                  title="Outras Características"
                >
                  <TabOutrasCaracteristicas
                    setTableData={setOutrasCaracteristica}
                    tableData={outrasCaracteristica}
                  />
                </Tab>
                <Tab
                  disabled={novo}
                  eventKey="linhasDeAplicacao"
                  title="Linhas de Aplicação"
                >
                  <TabLinhasDeAplicacao
                    selectLinhaAplicacao={selectLinhaAplicacao}
                    setLogoPreview={setLogoPreview}
                  />
                </Tab>
                <Tab
                  disabled={novo}
                  eventKey="imagensFichaTecnica"
                  title="Imagens"
                >
                  <TabImagens
                    setFiguraIcone={setFiguraIcone}
                    figuraIcone={figuraIcone}
                    disabled={novo}
                    situacao={idSituacaoGet}
                  />
                </Tab>
                <Tab
                  disabled={!tamanhoBarrasLiberado}
                  eventKey="tamanhosBarras"
                  title="Tamanhos de Barras"
                >
                  <TabTamanhosBarra material={material} />
                </Tab>
              </Tabs>
            </Form>
          </div>
        </div>

        {/* Modal Pré-visualização */}
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Pré-visualização</Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-3 pb-3">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-sm-6 col-lg-6 pl-0">
                    <div className="card card-sm">
                      <a className="d-block">
                        <Image
                          src={
                            figuraIcone.nomeImagem != null
                              ? baseUrlImagem +
                                emValidacao.current +
                                figuraIcone.nomeImagem
                              : Placeholder
                          }
                          onError={(event: any) =>
                            (event.target.src = Placeholder)
                          }
                          className="card-img-top"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-sm-6 pr-0">
                    <div className="card-body pb-0">
                      <div className="d-flex align-items-center">
                        <div>
                          {logoLinha && (
                            <Image
                              src={URL.createObjectURL(base64toBlob(logoLinha))}
                              width="180px"
                              onError={(event: any) =>
                                (event.target.src = Placeholder)
                              }
                              className="pb-4"
                            />
                          )}
                          <div className="font-weight-bold">
                            {material?.codigo}
                          </div>
                          <div>{material?.descricao}</div>
                          <div className="row text-muted mt-3">
                            <div className="col-sm-12">
                              <div className="row">
                                <div className="col-sm-12">
                                  <span className="font-weight-bold">
                                    Linha:
                                  </span>
                                  <span className="ml-1">
                                    {material?.linha.label}
                                  </span>
                                </div>
                                <div className="col-sm-12">
                                  <span className="font-weight-bold">
                                    Peso:
                                  </span>
                                  <span className="ml-1">{material?.peso}</span>
                                </div>
                                <div className="col-sm-12">
                                  <span className="font-weight-bold">
                                    Tamanho da Barra:
                                  </span>
                                  <span className="ml-1">
                                    {material?.barra1} (mm)
                                  </span>
                                  {material?.barra2 != "" && (
                                    <span>, {material?.barra2} (mm)</span>
                                  )}
                                  {material?.barra3 != "" && (
                                    <span>, {material?.barra3} (mm)</span>
                                  )}
                                </div>

                                {material?.composto?.value === 3 && (
                                  <div className="col-sm-12">
                                    <span className="font-weight-bold">
                                      Perfil Composto
                                    </span>
                                  </div>
                                )}
                                <div className="mt-3 col-sm-12">
                                  <span className="badge badge-xl bg-green-lt text-uppercase h4">
                                    {material?.situacao.label}
                                  </span>
                                  <span className="ml-1 badge badge-xl bg-azure-lt text-uppercase h4">
                                    {material?.status.label}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {logoPreview.length != 0 && (
                  <div className="card row mt-3">
                    <div className="card-header">
                      <h3 className="card-title">APLICÁVEL NAS LINHAS:</h3>
                    </div>
                    <div className="card-body">
                      <div className="col-sm-12">
                        <div className="row">
                          {logoPreview.map((logoReferencia, index) => (
                            <div className="col-sm-3" key={index}>
                              {
                                <Image
                                  src={URL.createObjectURL(
                                    base64toBlob(logoReferencia)
                                  )}
                                  onError={(event: any) =>
                                    (event.target.src = Placeholder)
                                  }
                                  width="80px"
                                />
                              }
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {outrasCaracteristica.length != 0 && (
                  <div className="card row mt-3">
                    <div className="card-header">
                      <h3 className="card-title">OUTRAS CARACTERÍSTICAS:</h3>
                    </div>
                    <div className="card-body">
                      <div className="row text-muted">
                        <div className="col-sm-12">
                          <div className="row">
                            {outrasCaracteristica.map(
                              ({ nome, descricao }, index) => (
                                <div className="col-sm-6" key={index}>
                                  <span className="font-weight-bold">
                                    {nome}:
                                  </span>{" "}
                                  {descricao}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  );
};
export default Perfil;
